import { Navigate, createBrowserRouter, type RouteObject } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { ExceptionsListPage } from '@/pages/ExceptionsListPage';
import { ExceptionDetailPage } from '@/pages/ExceptionDetailPage';
import { DraftsPage } from '@/pages/DraftsPage';
import { FeedbackPage } from '@/pages/FeedbackPage';
import { AdminPage } from '@/pages/AdminPage';
import { SignedOutPage } from '@/pages/SignedOutPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

const routeTree: RouteObject[] = [
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/queue" replace /> },
      { path: 'queue', element: <ExceptionsListPage /> },
      { path: 'queue/:id', element: <ExceptionDetailPage /> },
      { path: 'exceptions', element: <Navigate to="/queue" replace /> },
      { path: 'exceptions/:id', element: <ExceptionDetailPage /> },
      { path: 'drafts', element: <DraftsPage /> },
      { path: 'feedback', element: <FeedbackPage /> },
      { path: 'admin', element: <AdminPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  { path: '/signed-out', element: <SignedOutPage /> },
];

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter(routeTree);
